// Who may change a picture (docs/plans/admin.md, Phase 2). The picture panel asks this before it offers any change
// (upload, library, frame, remove), including the Basement overlay image (an art slot), and empty slots are only
// selectable when it answers true. While the server does not lock `art` (EDIT_LOCK), everyone may change every
// slot, as before; with the lock on, only a browser in edit mode (the admin link, net/editor.ts). The server's check
// is EditGate.canEdit(room, session, "art") on every art write. Changes stay shared with everyone in the room.

import { mayEdit } from '../net/editor';

/** May this visitor change the picture in `slot` of `room`? (Every editor may edit every room for now.) */
export function canEditArt(_room: string, _slot: string): boolean {
  return mayEdit('art');
}
